import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavController, PopoverController } from '@ionic/angular';

import { Storage } from '@ionic/storage-angular';

import { MdlReportesDescargablesPage } from 'src/app/pages/mdl-reportes-descargables/mdl-reportes-descargables.page';

@Component({
  selector: 'app-menu-popover',
  templateUrl: './menu-popover.component.html',
  styleUrls: ['./menu-popover.component.scss'],
})
export class MenuPopoverComponent implements OnInit {
  idAdmin: any;
  storageUsuario: any;

  isDashboardVisible = false;
  isPlatillasVisible = false;
  isContactosVisible = false;
  isInformesVisible = false;
  isReportesVisible = false;
  isHorariosVisible = false;
  isLicenciasVisible = false;
  isConfiguracionVisible = false;
  isEnviosDisponiblesVisible = false;

  menu = {
    dashboard: false,
    plantillas: false,
    informes: false,
    configuracion: false
  };

  submenus = {
    licencias: false,
  };

  constructor(
    private navCtrl: NavController,
    private modalController: ModalController,
    private popoverController: PopoverController,
    private router: Router,
    private storage: Storage) { }

  ngOnInit() {
    this.storage.get('usuario').then((usuario) => {
      this.storageUsuario = usuario;
    })
      .then(() => {
        this.idAdmin = this.storageUsuario.idAdmin;
      });

    this.checkUrl();
  }

  toggleMenu(menuName: string) {
    const isMenuCurrentlyOpen = this.menu[menuName];

    this.menu = {
      dashboard: false,
      plantillas: false,
      informes: false,
      configuracion: false
    };

    if (!isMenuCurrentlyOpen) {
      this.menu[menuName] = true;
    }
  }

  toggleSubMenu(submenuName: string) {
    this.submenus[submenuName] = !this.submenus[submenuName];
  }

  ir(ruta: string) {
    this.navCtrl.navigateForward('/folder/' + ruta).then(() => {
      if (ruta === 'inicio') {
        window.location.reload();
      }
      this.closePopover();
    });
  }

  async closePopover() {
    await this.popoverController.dismiss();
  }

  checkUrl() {
    const currentUrl = this.router.url;

    if (currentUrl === '/folder/dashboard-mejorada') {
      this.isDashboardVisible = true;
      this.isPlatillasVisible = true;
      this.isInformesVisible = true;
      this.isConfiguracionVisible = true;
      this.isLicenciasVisible = true;
      this.isEnviosDisponiblesVisible = true;
    } else {
      this.isDashboardVisible = true;
      this.isPlatillasVisible = true;
      this.isInformesVisible = true;
      this.isConfiguracionVisible = true;
      this.isLicenciasVisible = true;
    }
  }

  async modalReportes() {
    const modal = await this.modalController.create({
      component: MdlReportesDescargablesPage,
      cssClass: 'animate__animated animate__slideInRight',
      showBackdrop: false,
      mode: 'ios',
      componentProps: {
        idAdmin: this.idAdmin,
      },
    });
    this.closePopover();
    return await modal.present();
  }
}
